

















import { Vue, Component } from "vue-property-decorator"
import { mapGetters } from "vuex"
@Component({
    computed: {
        ...mapGetters(["noPermission"])
    }
})
export default class DefaultError extends Vue {
    goHome() {
        this.$router.push("/")
    }
}
